import { BFF_ANALYZE_API } from "../../config/endpoints";

export const analyzeRally = async (requestData) => {
    try {
        console.log("🚀 Making BFF API call to:", BFF_ANALYZE_API);
        console.log("📤 Request data:", requestData);
        
        const response = await fetch(BFF_ANALYZE_API, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        console.log("📥 Response status:", response.status);
        console.log("📥 Response headers:", response.headers);

        if (!response.ok) {
            const errorText = await response.text();
            console.error("❌ Response error text:", errorText);
            throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
        }

        const result = await response.json();
        console.log("✅ BFF API response:", result);
        return result;
    } catch (error) {
        console.error("❌ BFF API Error:", error);
        console.error("❌ Error details:", {
            message: error.message,
            stack: error.stack,
            url: BFF_ANALYZE_API
        });
        throw error;
    }
}; 